import axios from 'axios'
import { host } from '../../../helper/config'

const PLUGINS_NAME = 'admin-statistic'

export const getTicketSourceSummary = async (token) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/get-ticket-source-summary`, {}, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  if (response && response.status === 200) {
    return response.data || {}
  }
  return null
}

export const getTicketSourceSummaryByDate = async (token, query) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/get-ticket-source-summary`, query, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  if (response && response.status === 200) {
    return response.data || {}
  }
  return null
}
